import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TestimonialSlider from '../../components/v3/TestimonialSlider/TestimonialSlider';
import TruestedSection from '../../components/v4/TrustedSection/TruestedSection';
import LottieIcon from '../../components/v4/LottieIcon';
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";

//animation
import aiMessageAnimation from "../../animations/v3/aiFeatures/aiMessageAnimation.json";

//images
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";


// import aiIcon from "../../images/v4/aiFeatures/aiChatbot/icons/aiIcon.svg";
import aiIcon from "../../images/v4/aiFeatures/aiChatbot/images/aiIcon.png";

import clientScrollGreenBg from "../../images/v4/aiFeatures/aiSalesInsight/images/clientScrollGreenBg.png";
import heroSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/heroSectionBg.png";
import flipSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/flipSectionBg.png";
import tabsSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/tabsSectionBg.png";
import accordianTabsBg from "../../images/v4/aiFeatures/aiChatbot/images/accordianTabsBg.png";
import growingBusinessBg from "../../images/v4/aiFeatures/aiChatbot/images/growingBusinessBg.png";
import benefitSection1Bg from "../../images/v4/aiFeatures/aiSalesInsight/images/benefitSection1Bg.png";
import cardsSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/cardsSectionBg.png";

import cardImg1 from "../../images/v4/aiFeatures/aiSmartMessaging/images/cardImg1.webp";
import cardImg2 from "../../images/v4/aiFeatures/aiSmartMessaging/images/cardImg2.webp";

import realWorldImg1 from "../../images/v4/aiFeatures/aiSmartMessaging/images/realWorldImg1.webp";
import realWorldImg2 from "../../images/v4/aiFeatures/aiSmartMessaging/images/realWorldImg2.webp";
import realWorldImg3 from "../../images/v4/aiFeatures/aiSmartMessaging/images/realWorldImg3.webp";
import realWorldImg4 from "../../images/v4/aiFeatures/aiSmartMessaging/images/realWorldImg4.webp";
import realWorldImg5 from "../../images/v4/aiFeatures/aiSmartMessaging/images/realWorldImg5.webp";


import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import growingIcon1 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/growingIcon4.svg";
import growingIcon5 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/growingIcon5.svg";
import growingIcon6 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/growingIcon6.svg";

import bentoSectionImg1 from "../../images/v4/aiFeatures/aiChatbot/images/bentoSectionImg1.webp";
import bentoCardBg from "../../images/v4/aiFeatures/aiSmartMessaging/images/bentoCardBg.png";
import bentoSectionBg1 from "../../images/v4/aiFeatures/aiSmartMessaging/images/bentoSectionBg1.webp";
import bentoSectionBg2 from "../../images/v4/aiFeatures/aiSmartMessaging/images/bentoSectionBg2.webp";
import bentoSectionBg3 from "../../images/v4/aiFeatures/aiSmartMessaging/images/bentoSectionBg3.webp";
import bentoSectionBg4 from "../../images/v4/aiFeatures/aiSmartMessaging/images/bentoSectionBg4.webp";
import bentoSectionBg5 from "../../images/v4/aiFeatures/aiSmartMessaging/images/bentoSectionBg5.webp";

import flipCardImg from "../../images/v4/aiFeatures/aiSmartMessaging/images/flipCardImg.webp";




import featureContainerImg from "../../images/v4/aiFeatures/aiSalesInsight/images/featureContainerImg.png";

import flipIcon1 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/flipIcon1.svg";
import flipIcon2 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/flipIcon2.svg";
import flipIcon3 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/flipIcon3.svg";
import flipIcon4 from "../../images/v4/aiFeatures/aiSmartMessaging/icons/flipIcon4.svg";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/transparentLogos/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/transparentLogos/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/transparentLogos/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/transparentLogos/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/transparentLogos/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/transparentLogos/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/transparentLogos/client7.png";

const useStyles = makeStyles((theme) => ({
    heroSection: {
        marginBottom:'-1px',
        paddingTop: '120px',
        backgroundImage: `url(${heroSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            paddingTop: '0',
            paddingBottom: '0'
        }
    },
    heroSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '90%',
        margin: '0 auto',
        gap: '24px',
        textAlign: 'center',
        "& span": {
            // background:
            //     "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
            // WebkitBackgroundClip: "text",
            // WebkitTextFillColor: "transparent",
            display: 'inline-flex',
            alignItems: 'baseline',
            justifyContent: 'flex-start',
            gap: '12px',
            "& img": {
                    height: '50px',
                    width: '50px'
                },
                "@media only screen and (max-width: 1200px)": {
                    "& img": {
                    height: '35px',
                    width: '35px'
                },
                },
            "@media only screen and (max-width: 600px)": {
                "& img": {
                    height: '28px',
                    width: '28px'
                }
            }
        },

    },
    accordianTabs: {
        backgroundImage: `url(${accordianTabsBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "& .headercenterContainer": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "64px",
            textAlign: 'center',
            gap: "30px",
            "& h2": {
                width: "100%",
            },
            "& p": {
                width: "100%",
            },
            "@media (max-width:768px)": {
                flexDirection: "column",
                gap: "18px",
                marginBottom: "55px",
                "& h2": {
                    width: "100%",
                },
                "& p": {
                    width: "100%",
                },
            },
        },
    },
    absoulteCard: {
        position: "absolute",
        margin: "0 auto",
        width: "100%",
        top: "-20%",
        "@media only screen and (max-width: 600px)": {
            top: "-15%",
        },
    },
    tabsSection: {
        backgroundImage: `url(${tabsSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        paddingTop: "300px",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "& $supportBox": {
            position: "absolute",
            top: "-530px",
            "@media only screen and (max-width: 600px)": {
                top: "-800px",
                marginTop: 0,
            },
        },
        "@media only screen and (max-width: 600px)": {
            paddingTop: "120px",
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    tabsContainer: {
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
        border: "2px solid #DBDBDB",
        borderRadius: "40px",
        background: "#fff",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "10px",
            padding: "5px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
                display: "none",
            },
        },
    },
    tab: {
        width: "max-content",
        background: "",
        padding: "18px 32px",
        background: "transparent",
        borderRadius: "40px",
        background: "transparent",
        transition: "0.3s ease",
        cursor: "pointer",
        "&.active": {
            color: "white",
            background:
                "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
        },
        "@media only screen and (max-width: 600px)": {
            minWidth: "max-content",
            padding: "10px 15px",
        },
    },
    tabCard: {
        marginTop: "65px",
        gap: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 600px)": {
            marginTop: "30px",
            flexDirection: "column",
        },
    },
    tabCardLeftContainer: {
        width: "50%",
        display: "flex",
        gap: "40px",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            gap: "20px",
            width: "100%",
        },
    },
    tabCardRightContainer: {
        width: "50%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },

    tabListContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "30px",
        marginTop: "50px",
        "@media only screen and (max-width: 600px)": {
            gap: "15px",
            marginTop: "20px",
        },
    },
    tabListItem: {
        display: "flex",
        width: "100%",
        margin: "0 auto",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "15px",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "15px",
            alignItems: "flex-start",
        },
    },
    tabListItemContent: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "10px",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    wpFaq: {
        // paddingTop: "120px",
        "@media only screen and (max-width: 600px)": {
            "& section": {
                padding: "0px 0 0 !important",
            },
        },
    },
    commonPageFooterSection: {
        background:
            " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    partnerSlide: {
        width: "144px !important",
        "& img": {
            width: "144px",
            filter: "brightness(0)",
        },
        "@media only screen and (max-width: 600px)": {
            width: "max-content !important",
            "& img": {
                width: "100px",
            },
        },
    },
    partnerSlider: {
        padding: "10px 0 60px !important",
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "40px !important",
        },
    },
    growingBusiness: {
        backgroundImage: `url(${growingBusinessBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: "80px",
        position: "relative",
        "& .header": {
            width: "55%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
            gap: "32px",
        },
        "& $featureContainer": {
            gap: "20px",
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "50px",
            "& .header": {
                width: "100%",
            },
        },
    },
    broadcastContainerInner: {
        gap: "30px",
        width: "100%",
        display: "flex",
        padding: "0 16rem 0rem 16rem",
        paddingTop: "10px  !important",
        paddingBottom: "10px  !important",
        alignItems: "stretch",
        justifyContent: "flex-start",
        "& swiper-wrapper": {
            alignItems: "stretch !important",
        },

        "& $featureContainer": {
            width: "31%",
            height: "auto  !important",
        },
        "@media only screen and (max-width: 600px)": {
            padding: "0 15px !important",
            paddingBottom: "10px !important",
        },
        "@media only screen and (min-width: 1900px)": {
            paddingLeft: "23rem !important",
            paddingRight: "23rem !important",
        },
    },
    featureContainer: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "32%",
        gap: "22px",
        boxShadow: "0px 0px 16px #C1D7DB66",
        borderRadius: "16px",
        background: "#fff",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        textAlign: "left",
        "& p": {
            width: "90%",
        },
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "& p": {
                width: "100%",
            },
        },
    },
    trustedSection: {
        "& .trustedHeading": {
            textAlign: 'center'
        }
    },
    cardsSection: {
        marginBottom:'-1px',
        backgroundImage: `url(${cardsSectionBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        "& .header": {
            display: "flex",
            marginBottom: "64px",
            width: "100%",
            gap: "32px",
            flexDirection: "column",
            "& h2": {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "5px",
            },
            "& p": {
                width: "80%",
            },
            "@media only screen and (max-width: 600px)": {
                marginBottom: "40px",
            },
        },
        "& .cardImg": {
            "& img": {
                width: "100%",
                height: "100%",
            },
        },
        "@media only screen and (max-width: 600px)": {
            "& .cardImg": {
                width: "100%",
                height: "100%",
                marginBottom: "15px",
                marginTop: "0",
                "& img": {
                    width: "100%",
                    height: "100%",
                },
            },
        },
    },
    bentoContainer: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '20px',
        width: '100%',
        marginTop: '40px',
    },
    bentoRow1: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        gap: '20px',
        width: '100%',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    bentoRow2: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        gap: '20px',
        width: '100%',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    bentoRow3: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        gap: '20px',
        width: '100%',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    bentoCard: {
        overflow: 'hidden',
        position: 'relative',
        zIndex: "1",
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        gap: '20px',
        borderRadius: '16px',
        backgroundSize: 'cover',
        backgroundPosition: 'top left',
        backgroundRepeat: 'no-repeat',
        minHeight: '330px',
        "& .content": {
            padding: '25px',
            display: 'flex',
            width: '100%',
            flexDirection: "column",
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '12px',
        },
        "@media only screen and (max-width: 600px)": {
            minHeight: '300px'
        },
        "@media only screen and (min-width: 1900px)": {
            minHeight: '380px'
        },
        "&.card1": {
            width: '32%',
            backgroundImage: `url(${bentoSectionBg1})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg1Mob})`,
                width: '100%'
            }
        },
        "&.card2": {
            width: '32%',
            backgroundImage: `url(${bentoSectionBg2})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg2Mob})`,
                width: '100%'
            }
        },
        "&.card3": {
            width: '32%',
            backgroundImage: `url(${bentoSectionBg3})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg3Mob})`,
                width: '100%'
            }

        },
        // "&.card4": {
        //     width: '100%',
        //     backgroundImage: `url(${bentoSectionBg4})`,
        //     "@media only screen and (max-width: 600px)": {
        //         // backgroundImage: `url(${bentoSectionBg4Mob})`,
        //         width: '100%'
        //     },
        //     "& .content": {
        //         width: '50%',
        //         "@media only screen and (max-width: 600px)": {
        //             width: '100%'
        //         },
        //     }
        // },
        "&.card5": {
            width: '49%',
            backgroundImage: `url(${bentoSectionBg4})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg5Mob})`,
                width: '100%'
            }
        },
        "&.card6": {
            width: '49%',
            backgroundImage: `url(${bentoSectionBg5})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg5Mob})`,
                width: '100%'
            }
        },
        "&.blueCard": {
            // background: "#053333",
            // "&:hover": {
            //   boxShadow: "0 0 16px 2px #009A99;",
            // },
            "& .offPrice": {
                background: '#009A99'
            },
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "250px",
                    height: "250px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #1ADAD9 30%, #00aa7c 50%)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "&.regularCard": {
            // background: "#0A2F4F",
            // "&:hover": {
            //   boxShadow: "0 0 16px 2px #208EEC;",
            // },
            "& .offPrice": {
                background: '#208EEC'
            },
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "250px",
                    height: "250px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "&.purpleCard": {
            // background: "#31114B",
            // "&:hover": {
            //   boxShadow: "0 0 16px 2px #9E5AD5;",
            // },
            "& .offPrice": {
                background: '#9E5AD5'
            },
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "400px",
                    height: "400px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #FF8958 0%, #B458FF 100%)",
                    borderRadius: "50%",
                    filter: "blur(200px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
    },
    benefitSection1: {

        backgroundImage: `url(${benefitSection1Bg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        background: "#F7F1FB",
        // paddingTop: '310px',
        "& .centerContainer": {
            display: "flex",
            justifyContent: "center",
            alignItems: 'center',
            flexDirection: 'column',
            gap: "32px",
            width: "80%",
            margin: "0 auto",
            textAlign: "center",
            "& h2": {
                flex: 1,
            },
            "& p": {
                flex: 1,
            },
        },
        "@media only screen and (max-width:  768px)": {
            "& .centerContainer": {
                width: '100%',
                flexDirection: "column",
            },
        },

        "& .benefits": {
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            margin: "60px 0",
            marginBottom: '0',
            "& .imageColumn": {
                width: "33%",

                "& img": {
                    width: "100%",
                },
                "& .featureContainer": {
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    height:'100%',
                    gap: "22px",
                    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                    background: "rgba(158, 90, 213, 0.20)",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    marginBottom: "0",
                    minHeight: "48%",
                    "& p": {
                        // color: $black2,
                        width: "90%",
                    },
                    "@media only screen and (max-width: 600px)": {
                        width: "100%",
                        minHeight: "0",
                        "& p": {
                            width: "100%",
                        },
                    },
                    "& .border": {
                        borderTop: '1px solid #fefefe42'
                    }
                },
            },

            "& .featureColumn": {
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "33%",
                "& .featureContainer": {
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    gap: "22px",
                    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                    // background: "rgba(158, 90, 213, 0.20)",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    marginBottom: "0",
                    minHeight: "48%",
                    "& p": {
                        // color: $black2,
                        width: "85%",
                    },
                     "@media only screen and (max-width: 1250px)": {
                        height:'300px'
                     },
                    "@media only screen and (max-width: 600px)": {
                        width: "100%",
                        "& p": {
                            width: "100%",
                        },
                    },
                    "& .border": {
                        borderTop: '1px solid #fefefe42'
                    }
                },
                "&:first-child": {
                    "& .featureContainer:first-child": {
                        minHeight: '52%'
                    },
                    "& .featureContainer:last-child": {
                        minHeight: '48%'
                    },
                },
                "&:last-child": {
                    "& .featureContainer:last-child": {
                        minHeight: '52%'
                    },
                    "& .featureContainer:first-child": {
                        minHeight: '45%'
                    },
                },
            },

            "@media only screen and (max-width:  768px)": {
                flexDirection: "column",
                gap: "20px",
                marginBottom: "0",
                marginTop:'40px',
                width:'70%',
                margin:'auto',
                "& .imageColumn": {
                    width: "100%",
                    "& .featureContainer": { minHeight: "0" },
                },

                "& .featureColumn": {
                    width: "100%",
                    "& .featureContainer": { minHeight: "0" },
                },
            },
            "@media only screen and (max-width:  600px)": {
                 width:'100%',
            }
        },
    },
    flipSection: {
        marginBottom:'-1px',
        backgroundImage: `url(${flipSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "80%",
            margin: "0 auto",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    flipCard: {
        background: "linear-gradient(270deg, #0A2F4F 0%, #2576BB 100%)",
        boxShadow: "0 0 20px 0 rgba(1, 15, 29, 0.20)",
        borderRadius: "24px",
        overflow: "hidden",
        display: "flex",
        width: "100%",
        marginTop: '40px',
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "40px",
        "@media only screen and (max-width: 600px)": {
            flexDirection: "column",
            padding: '15px',
            gap: '30px'
        },
    },
    flipCardLeft: {
        width: "50%",
        display: "flex",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    flipCardRight: {
        width: "50%",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            padding: "0",
            gap: "20px",
        },
    },
    flipCardRightHeader: {
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
    },
    flipCardPointers: {
        display: "flex",
        gap: "40px",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
    },
    flipCardPointer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "45%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    clientScrollSection: {
        backgroundImage: `url(${clientScrollGreenBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: '220px',
        "& section": {
            padding: '0 !important'
        }
    },

    bentoSection: {
        marginBottom:'-1px',
        background: '#011C33',
        "& .centerContainer": {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            "& h2": {
                widht: '45%',
                "@media only screen and (max-width: 600px)": {
                    width: '100%'
                }
            },
            "& p": {
                widht: '45%',
                "@media only screen and (max-width: 600px)": {
                    width: '100%'
                }

            },
            "@media only screen and (max-width: 600px)": {
                flexDirection: 'column'
            }
        },
    }
}));

const AiMessageModule = () => {

    // desclaration
    const classes = useStyles();
    const [activeAccordian, setActiveAccordian] = useState(0);
    const [activeRealWorld, setActiveRealWorld] = useState(0);

    const { ref, inView } = useInView({
        threshold: 0.5, // adjust as needed
        triggerOnce: false,
    });

    // glass-effect-code
    useEffect(() => {
        // Select all cards that should have the effect
        const cardsToAnimate = [

            ...document.querySelectorAll(`.${classes.bentoCard}.purpleCard`), // Add regularCards
            ...document.querySelectorAll(`.${classes.bentoCard}.blueCard`),
            ...document.querySelectorAll(`.${classes.bentoCard}.regularCard`), // Add regularCards
        ];

        cardsToAnimate.forEach((card) => {
            if (!card) return;

            card.classList.add("glass-effect");

            // Set initial top-right position for the glass effect
            const setInitialPosition = () => {
                const rect = card.getBoundingClientRect();
                const topRightX = rect.width - 150; // Adjust this value to position from right edge
                const topRightY = 0; // Top position

                card.style.setProperty("--before-left", `${topRightX}px`);
                card.style.setProperty("--before-top", `${topRightY}px`);
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Call it initially
            setInitialPosition();

            let lastX = null;
            let lastY = null;

            const handleMouseMove = (e) => {
                const rect = card.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                lastX = x;
                lastY = y;

                card.style.setProperty("--before-left", `${x - 75}px`);
                card.style.setProperty("--before-top", `${y - 75}px`);
            };

            const handleMouseEnter = () => {
                if (lastX !== null && lastY !== null) {
                    card.style.setProperty("--before-left", `${lastX - 75}px`);
                    card.style.setProperty("--before-top", `${lastY - 75}px`);
                }
                card.style.setProperty("--before-opacity", "0.8");
            };

            const handleMouseLeave = () => {
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Store handlers on the card element for cleanup
            card.handlers = {
                mousemove: handleMouseMove,
                mouseenter: handleMouseEnter,
                mouseleave: handleMouseLeave,
                resize: setInitialPosition,
            };

            // Add event listeners
            card.addEventListener("mousemove", handleMouseMove);
            card.addEventListener("mouseenter", handleMouseEnter);
            card.addEventListener("mouseleave", handleMouseLeave);
            window.addEventListener("resize", setInitialPosition);
        });

        // Cleanup
        return () => {
            cardsToAnimate.forEach((card) => {
                if (!card) return;

                const handlers = card.handlers;
                if (handlers) {
                    card.removeEventListener("mousemove", handlers.mousemove);
                    card.removeEventListener("mouseenter", handlers.mouseenter);
                    card.removeEventListener("mouseleave", handlers.mouseleave);
                    window.removeEventListener("resize", handlers.resize);
                }
            });
        };
    }, [classes]);
    // glass-effect-code

    //scrollableCards
    useEffect(() => {
        const cards = document.querySelectorAll(".card");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const card = entry.target;
                    const currentIndex = Array.from(cards).indexOf(card);

                    if (entry.isIntersecting) {
                        // Remove all previous classes first
                        cards.forEach((c) => {
                            c.classList.remove(
                                "is-previous-1",
                                "is-previous-2",
                                "is-previous-3",
                                "is-previous-4"
                            );
                        });

                        // Add appropriate classes based on distance from current card
                        cards.forEach((c, index) => {
                            if (index < currentIndex) {
                                const difference = currentIndex - index;
                                if (difference <= 4) {
                                    // Only apply effects to 4 cards back
                                    c.classList.add(`is-previous-${difference}`);
                                }
                            }
                        });
                    }
                });
            },
            {
                root: null,
                threshold: 0.5,
                rootMargin: "0px",
            }
        );

        cards.forEach((card) => observer.observe(card));

        return () => observer.disconnect();
    }, []);
    //scrollableCards

    // data

    const tabContentData = [
        {
            tabContent: [
                {
                    title: "Respond faster with AssistAI",
                    content:
                        "Use AI and knowledge base groups to handle queries instantly.",
                    alt: "E-commerce AI CRM",
                },
                {
                    title: "Tag chats for marketing",
                    content:
                        "Organise conversations for future campaigns and promotions.",
                    alt: "E-commerce AI CRM",
                },
                {
                    title: "Track sentiment trends",
                    content:
                        "Gain insight into customer mood with built-in AI analytics.",
                    alt: "E-commerce AI CRM",
                },
                {
                    title: "Product suggestions",
                    content:
                        "Use chat history to suggest relevant products during or after conversations.",
                    alt: "E-commerce AI CRM",
                },
            ],
            img: realWorldImg1,
            alt: "AI CRM for E-commerce",
            subtitle:
                "Deliver quicker support, smarter replies, and better engagement using smart CRM messaging with AI to scale service quality.",
        },
        {
            tabContent: [
                {
                    title: "Auto-answer queries",
                    content:
                        "Handle common admission and course questions with smart automation.",
                    alt: "AI CRM for Education",
                },
                {
                    title: "Create tasks instantly",
                    content:
                        "Turn chats into follow-up tasks and events in one click.",
                    alt: "AI CRM for Education",
                },
                {
                    title: "Track student sentiment",
                    content:
                        "Monitor engagement levels with built-in sentiment insights.",
                    alt: "AI CRM for Education",
                },
                {
                    title: "Tag enquiries",
                    content:
                        "Auto-categorise queries as admissions, courses, or others.",
                    alt: "AI CRM for Education",
                },
            ],
            img: realWorldImg2,
            alt: "AI CRM for Education",
            subtitle:
                "Keep admissions, queries, and student engagement streamlined with smart CRM tools that combine automation and conversation insights.",
        },
        {
            tabContent: [
                {
                    title: "Auto-create follow-ups",
                    content:
                        "Convert messages into tasks and reminders inside your CRM.",
                    alt: "AI CRM for Finance & Insurance",
                },
                {
                    title: "Reply with policy-aware AI",
                    content:
                        "Use AI-suggested responses tailored to financial and insurance terms.",
                    alt: "AI CRM for Finance & Insurance",
                },
                {
                    title: "Track sentiment for compliance",
                    content:
                        "Monitor tone and action items to stay audit-ready.",
                    alt: "AI CRM for Finance & Insurance",
                },
                {
                    title: "Quick summaries",
                    content:
                        "Turn long chats into concise policy or finance snapshots.",
                    alt: "AI CRM for Finance & Insurance",
                },
            ],
            img: realWorldImg3,
            alt: "AI CRM for Finance & Insurance",
            subtitle:
                "For client onboarding, policy discussions, and follow-ups, CRM messaging ensures speed, accuracy, and regulatory alignment.",
        },
        {
            tabContent: [
                {
                    title: "Log buyer chats automatically",
                    content:
                        "Instantly capture every buyer conversation into your simple sales CRM software.",
                    alt: "AI CRM for Real Estate",
                },
                {
                    title: "Auto-qualify leads with AI",
                    content:
                        "Let intelligent agents summarise and prioritise property leads in real time.",
                    alt: "AI CRM for Real Estate",
                },
                {
                    title: "Send smart, personalised replies",
                    content:
                        "Use AssistAI to respond instantly with the right tone and context.",
                    alt: "AI CRM for Real Estate",
                },
                {
                    title: "Smart listings",
                    content:
                        "Match buyer chats with properties and auto-send recommendations.",
                    alt: "AI CRM for Real Estate",
                },
            ],
            img: realWorldImg4,
            alt: "AI CRM for Real Estate",
            subtitle:
                "In a fast-moving market, agents rely on CRM messaging with AI to manage leads and speed up deal cycles using one simple interface.",
        },
        {
            tabContent: [
                {
                    title: "Convert chats to bookings",
                    content:
                        "Instantly create reminders or bookings from conversations.",
                    alt: "AI CRM for Travelling Agency",
                },
                {
                    title: "Answer FAQs with AI",
                    content:
                        "Use friendly AI assistants to handle common travel queries.",
                    alt: "AI CRM for Travelling Agency",
                },
                {
                    title: "Act on guest feedback",
                    content:
                        "Analyse sentiment in real time to improve service.",
                    alt: "AI CRM for Travelling Agency",
                },
                {
                    title: "Itinerary drafts",
                    content:
                        "Automatically generate personalised travel itineraries from chat inputs using AI.",
                    alt: "AI CRM for Travelling Agency",
                },
            ],
            img: realWorldImg5,
            alt: "AI CRM for Travelling Agency",
            subtitle:
                "From trip planning to customer care, Pepper Cloud CRM messaging with AI helps you personalise service and automate follow-ups.",
        },
    ];


    const partners = [
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    ];

    const faqs = [
        {
            question: "How does smart CRM messaging with AI help my sales team?",
            answer:
                "It helps your team respond faster with AI-suggested replies, while also allowing them to create tasks, events, or opportunities directly from the chat. With this level of efficiency, your team can focus more on closing deals and less on managing tools.",
        },
        {
            question: "Can I personalise the tone of AI-generated messages?",
            answer:
                "Yes. Using AssistAI, you can easily switch between formal, friendly, concise, or expanded tones. This ensures every message stays aligned with your brand voice and improves the customer experience.",
        },
        {
            question: "Is this feature available in your simple CRM plan?",
            answer:
                "Absolutely. Pepper Cloud’s simple CRM interface includes AI messaging as part of its sales communication tools—making it easy for teams of all sizes to adopt without complexity.",
        },
        {
            question: "How does the AI messaging module support automated customer service?",
            answer:
                "You can use the AssistAI knowledge base or select specific knowledge groups to automatically reply to customer queries. This makes your support experience more consistent, scalable, and efficient.",
        },
        {
            question: "What makes Pepper Cloud’s CRM messaging better than other tools?",
            answer:
                "Our CRM messaging with AI is built into your workflow. No switching tabs, no separate tools. You can chat, act, analyse, and close—all in one simple, smart interface powered by AI.",
        },
        {
            question: "Does the AI messaging module include intelligent agents?",
            answer:
                "Yes, it uses intelligent agents to suggest replies, summarise conversations, detect sentiment, and recommend next actions—helping your team stay on track and proactive.",
        },
    ];

    const growingList = [
        {
            icon: growingIcon1,
            background: "#F9F1FF",
            heading: "Faster response time with AssistAI",
            text: "Generate accurate, well-crafted replies in seconds. Save time while ensuring every customer message is handled professionally.",
        },
        {
            icon: growingIcon2,
            background: "#F4FAFF",
            heading: "Seamless task and deal creation",
            text: "Convert conversations into tasks or opportunities instantly. No need to switch tabs or tools—take action on the spot.",
        },
        {
            icon: growingIcon3,
            background: "#FFF5F1",
            heading: "Smarter replies using knowledge base",
            text: "Pull answers from AssistAI’s knowledge groups. Deliver consistent, helpful responses based on your business knowledge.",
        },
        {
            icon: growingIcon4,
            background: "#F9F1FF",
            heading: "Actionable insights from AI analytics",
            text: "View key conversation metrics, summaries, and sentiment. Make smarter follow-up decisions with real-time data.",
        },
        {
            icon: growingIcon5,
            background: "#FFF5E8",
            heading: "Improved customer experience with tone control",
            text: "Adjust message tone from formal to friendly or concise. Ensure every reply feels personal, consistent and brand-aligned.",
        },
        {
            icon: growingIcon6,
            background: "#F9F1FF",
            heading: "Real-time sentiment tracking",
            text: "Understand how customers feel, think, and react during chats. Proactively handle concerns before they escalate.",
        },
    ];
    const capabilities = [
        {
            heading: "Why your business needs smart CRM messaging",
            desc: "Managing conversations manually slows your team down. With CRM messaging powered by AI, you can automate responses, track customer sentiment, and take real-time action from one place. Using a Pepper Cloud simple sales CRM software, businesses can turn chats into opportunities, tasks, or notes—instantly. It’s the easiest way to boost productivity, improve service, and never miss a follow-up.",
            background: 'linear-gradient(99deg, #0D47C0 0%, #028376 100%)',
            img: cardImg1,
            alt: "AI Insights feature",
        },
        {
            heading: "What is AI Message Module?",
            desc: "The AI Message Module in Pepper Cloud is designed to bring intelligence, speed, and simplicity to your business conversations. With this feature built into your smart CRM, you can automate replies, create tasks or opportunities from messages, and gain real-time customer insights—without ever leaving the chat window.",
            background: 'linear-gradient(99deg, #31114B 2.21%, #783CA8 98.14%)',
            img: cardImg2,
            alt: "Conversational AI for sales",
        },
    ];

    const clientScrollData = {
        title: "Trusted by top brands across industries",
        backgroundImage: "",
        logos: [
            {
                img: clientLogo1,
            },
            {
                img: clientLogo2,
            },
            {
                img: clientLogo3,
            },
            {
                img: clientLogo4,
            },
            {
                img: clientLogo5,
            },
            {
                img: clientLogo6,
            },
            {
                img: clientLogo7,
            },
        ],
        directions: ["left", "right", "left"],
        speeds: [0.8, 0.4, 0.8],
    };

    return (
        <main>
            <SEO
                title={
                    "Smart CRM messaging with AI | AI communication assistant"
                }
                pathname={
                    "https://peppercloud.com/best-ai-crm-features/ai-chatbot-for-crm/"
                }
                keywords="Smart CRM Messaging with AI, smart crm, simple srm, crm messaging, simple sales crm software, CRM Messaging with AI, intelligent agents, automated customer service"
                description={"Transform how your team communicates with smart CRM messaging powered by AI. Rephrase, expand, or refine messages instantly using Pepper Cloud’s AI communication assistant."}
                ogData={{
                    "og:image": [
                        "/meta/og/1X1/home.png",
                        "/meta/og/1024X512/home.png",
                        "/meta/og/1200X630/home.png",
                    ],
                }}
                jsonLd={[
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Pepper Cloud",
                        legalName: "Pepper Cloud PTE LTD",
                        url: "https://peppercloud.com/",
                        logo: "https://peppercloud.com/icons/logo.png",
                        foundingDate: "2017",
                        address: [
                            {
                                "@type": "PostalAddress",
                                streetAddress: "#04-01/02",
                                addressLocality: "Blk 79 Ayer Rajah Crescent",
                                addressRegion: "SG",
                                postalCode: "139955",
                                addressCountry: "Singapore",
                            },
                            {
                                "@type": "PostalAddress",
                                streetAddress:
                                    "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                                addressLocality: "Bengaluru",
                                addressRegion: "KA",
                                postalCode: "560095",
                                addressCountry: "India",
                            },
                        ],
                        contactPoint: {
                            "@type": "ContactPoint",
                            contactType: "customer support",
                            telephone: "+6566562616",
                            email: ["sales@peppercloud.com", "support@peppercloud.com"],
                        },
                        sameAs: [
                            "https://twitter.com/peppercloudpte",
                            "https://www.linkedin.com/company/peppercloud/",
                            "https://www.facebook.com/PepperCloudPteLtd",
                            "https://www.instagram.com/pepper.cloud/",
                        ],
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        name: "AssistAI",
                        description:
                            "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
                        thumbnailUrl: [
                            "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
                        ],
                        uploadDate: "2024-12-02",
                        contentUrl:
                            "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
                        publisher: {
                            "@type": "Organization",
                            name: "Pepper Cloud",
                            logo: {
                                "@type": "ImageObject",
                                url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                                width: "",
                                height: "",
                            },
                        },
                        duration: "PT1M12S",
                    },
                    {
                        "@context": "https://schema.org/",
                        "@type": "FAQPage",
                        mainEntity: [
                            {
                                "@type": "Question",
                                name: "How does smart CRM messaging with AI help my sales team?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "It helps your team respond faster with AI-suggested replies, while also allowing them to create tasks, events, or opportunities directly from the chat. With this level of efficiency, your team can focus more on closing deals and less on managing tools.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Can I personalise the tone of AI-generated messages?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes. Using AssistAI, you can easily switch between formal, friendly, concise, or expanded tones. This ensures every message stays aligned with your brand voice and improves the customer experience.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Is this feature available in your simple CRM plan?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Absolutely. Pepper Cloud’s simple CRM interface includes AI messaging as part of its sales communication tools—making it easy for teams of all sizes to adopt without complexity.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "How does the AI messaging module support automated customer service?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "You can use the AssistAI knowledge base or select specific knowledge groups to automatically reply to customer queries. This makes your support experience more consistent, scalable, and efficient.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "What makes Pepper Cloud’s CRM messaging better than other tools?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Our CRM messaging with AI is built into your workflow. No switching tabs, no separate tools. You can chat, act, analyse, and close—all in one simple, smart interface powered by AI.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Does the AI messaging module include intelligent agents?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes, it uses intelligent agents to suggest replies, summarise conversations, detect sentiment, and recommend next actions—helping your team stay on track and proactive.",
                                },
                            }
                        ],
                    },
                ]}
            />
            <section className={classes.heroSection}>
                <div className='container'>
                    <div className={classes.heroSectionContainer}>
                        <motion.h1
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-semibold font-white font-64"> <span> <LazyImage source={aiIcon} alt={"AssistAi - Ai crm"} />Close </span>  deals faster using smart CRM messaging with AI</motion.h1>
                        <motion.p initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }} className='font-white font-wix-regular font-20'>With Smart CRM Messaging with AI, you can enhance replies, automate actions, and gain instant insights all within your CRM chat window.</motion.p>
                        <LottieIcon
                            autoplay
                            loop
                            animationData={aiMessageAnimation}
                            hover={false}
                            play
                        />
                <Link to="/contact/" className="font-18 font-white font-wix-medium primaryButton">Book a free demo</Link>
                    </div>
                </div>
                <div className='container'>
                    <LazyImage alt="AI CRM messaging dashboard" source={bentoSectionImg1} style={{ marginBottom: '40px' }} height={'100%'} width={'100%'} />
                </div>
            </section>
            <section className={classes.cardsSection}>
                <div className="container">
                    {/* <div className="header">
                        <motion.h2
                            className="font-wix-semibold font-56 font-white"
                            initial={{ opacity: 1, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                        >
                            AI insights that understand, act, and optimise your sales process
                        </motion.h2>
                    </div> */}
                    <ul id="cards">
                        {capabilities.map((data, index) => (
                            <li className="card" id={`card-${index + 1}`}>
                                <div
                                    className="card-content"
                                    style={{
                                        background: `${data.background}`,

                                    }}
                                >
                                    <div className="cardImg">
                                        <img alt={data.alt} src={data.img} />
                                    </div>
                                    <div className="cardContentData">
                                        <h3 className="cardHeading font-wix-medium">
                                            {data.heading}
                                        </h3>
                                        <p className="cardDesciption">{data.desc}</p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
            <section className={classes.benefitSection1}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Improve speed, accuracy, and customer satisfaction with AI

                        </motion.h2>
                        {/* <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            Let your sales and support teams work smarter and faster with Pepper Cloud’s conversational AI. Here’s the impact real teams have seen
                        </motion.p> */}
                    </div>

                    <div className="benefits">
                        <div className="imageColumn">
                            <div className="featureContainer" style={{ background: 'linear-gradient(127deg, #0A2F4F 3.57%, #2576BB 100%)' }}>
                                <p className='font-wix-semibold font-56 font-white'>50%</p>
                                <p className="font-wix-medium font-24 font-white">
                                    faster task creation
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    Convert messages into tasks or deals instantly from the conversation view.
                                </p>
                                <LazyImage
                                    source={featureContainerImg}
                                    alt={"Conversational AI in CRM"}
                                    width={"100%"}
                                />
                            </div>

                        </div>
                        <div className="featureColumn">
                            <div className="featureContainer" style={{ background: 'radial-gradient(50% 100% at 50% 0%, rgba(158, 90, 213, 0.80) 0%, rgba(158, 90, 213, 0.00) 100%), linear-gradient(180deg, rgba(158, 90, 213, 0.20) 0%, rgba(158, 90, 213, 0.16) 100%)' }} >
                                <p className='font-wix-semibold font-56 font-white'>2x</p>
                                <p className="font-wix-medium font-24 font-white">
                                    more customer satisfaction
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    Send context-rich, personalised responses powered by AI for faster resolutions and deeper customer connections.
                                </p>
                            </div>

                            <div className="featureContainer" style={{ background: 'linear-gradient(127deg, #31114B 4.23%, #783CA8 100%)' }}>
                                <p className='font-wix-semibold font-56 font-white'>3x</p>
                                <p className="font-wix-medium font-24 font-white">
                                    better team productivity
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    Let your team reply, assign, and update records all in one place.
                                </p>
                            </div>
                        </div>
                        <div className="featureColumn">
                            <div className="featureContainer" style={{
                                backgroundImage: `url(${bentoCardBg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover',
                                imageRendering: 'pixelated'
                            }}>
                            </div>
                            <div className="featureContainer" style={{ background: "linear-gradient(127deg, #053333 1.96%, #009A99 100%)" }}>
                                <p className='font-wix-semibold font-56 font-white'>70%</p>
                                <p className="font-wix-medium font-24 font-white">
                                    reduced response time
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    Use smart suggestions and templates to craft quick, accurate replies, save effort, boost efficiency, personalise messages, and respond faster at scale.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.growingBusiness}>
                <div className="container">
                    <div className="header">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-black1"
                        >
                            Benefits of using AI in message module

                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-18 font-black1"
                        >
                            Pepper Cloud’s AI Message Module empowers your business to handle every conversation with speed, intelligence, and impact. From smart replies to automated workflows, it helps teams stay focused and efficient.
                        </motion.p>
                    </div>
                </div>
                <Swiper
                    slidesPerView={3.3}
                    // centeredSlides={true}
                    spaceBetween={30}
                    grabCursor={true}
                    loop={false}
                    speed={5000}
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    // freeMode={true}
                    className={classes.broadcastContainerInner}
                    breakpoints={{
                        // For smaller screens (mobile)
                        0: {
                            slidesPerView: 1.3,
                            slidesPerGroup: 1,
                            freeMode: true,
                            grabCursor: false,
                            allowTouchMove: true,
                            spaceBetween: 10,
                        },
                        // For larger screens (desktop)
                        768: {
                            slidesPerView: 3.3,
                            centeredSlides: false,
                            spaceBetween: 30,
                            grabCursor: true,
                        },
                    }}
                >
                    {growingList.map((feature) => (
                        <SwiperSlide
                            className={classes.featureContainer}
                        //   style={{ background: feature.background }}
                        >
                            <LazyImage
                                source={feature.icon}
                                alt={"AI summarising customer conversations"}
                                className={classes.featureIcon}
                            // alt={listItem.alt}
                            />
                            <p className="font-wix-semibold font-24 color-black1">
                                {feature.heading}
                            </p>
                            <p className="font-wix-mediu font-18 color-black1">
                                {feature.text}
                            </p>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
            </section>
            <section className={classes.bentoSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Pepper Cloud has the best AI messaging module
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-regular font-18 font-white"
                        >
                            Pepper Cloud goes beyond basic chat. It uses AI to turn every message into a smart action, helping your team respond faster, stay organised, and close deals more efficiently—without switching tools or tabs.

                        </motion.p>
                    </div>
                    <div className={classes.bentoContainer}>
                        <div className={classes.bentoRow1}>
                            <div className={clsx(classes.bentoCard, 'card1', "regularCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Turn conversations into tasks, events, or deals instantly, so your team never misses a follow-up or sales opportunity.</p>
                                </div>
                            </div>
                            <div className={clsx(classes.bentoCard, 'card2', "purpleCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Write polished, on-brand replies with AssistAI—adjust tone, fix grammar, or rephrase messages in just one click.</p>

                                </div>
                            </div>
                            <div className={clsx(classes.bentoCard, 'card3', "regularCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Deliver consistent, accurate replies by pulling answers directly from your AssistAI knowledge base.</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.bentoRow3}>
                            <div className={clsx(classes.bentoCard, 'card5', "purpleCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Track sentiment, summaries, quotes, emotions, intent, and action items in real time for complete visibility into every customer interaction.</p>

                                </div>
                            </div>
                            <div className={clsx(classes.bentoCard, 'card6', "blueCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Keep every message human and context-aware with conversational AI that adapts to your brand’s tone and the customer’s behaviour.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.flipSection}>
                <div className='container'>
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Key features of the AI message module for modern businesses
                        </motion.h2>
                    </div>
                    <div
                        className={classes.flipCard}
                    >
                        <div className={classes.flipCardLeft}>
                            {/* keep your LazyImage usage */}
                            <LazyImage
                                source={flipCardImg}
                                width={"100%"}
                                alt="AI extracting sales action points"
                            />
                        </div>

                        <div className={classes.flipCardRight}>
                            <div className={classes.flipCardRightHeader}>
                                {/* <h2
                                    className="font-40 font-wix-medium color-black1"
                                    style={{ margin: 0 }}
                                >
                                    {card.heading}
                                </h2> */}
                                <p
                                    className="font-18 font-wix-regular font-white"
                                >
                                    The AI Message Module in Pepper Cloud is packed with smart tools to streamline communication, boost productivity, and support your sales process, right from the chat window.
                                </p>
                            </div>

                            <div className={classes.flipCardPointers}>

                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="Smart message replies" source={flipIcon1} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Smart message replies
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Instantly rewrite, expand, or personalise responses, adjust tone, or fix grammar in just one click—making every reply sound just right.
                                    </p>
                                </div>
                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="Task from chat" source={flipIcon2} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Task from chat
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Create tasks, events, or deals directly from chats, so you stay organised and never have to switch tabs to follow up on important conversations.
                                    </p>
                                </div>
                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="AI-powered replies" source={flipIcon3} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        AI-powered replies
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Deliver fast, accurate, and contextual answers automatically—using your CRM’s knowledge base for each auto-reply.
                                    </p>
                                </div>
                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="AI-driven insights" source={flipIcon4} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        AI-driven insights
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Track sentiment, capture quotes, or highlight key actions in real time—get instant insights to guide every reply.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.clientScrollSection}>
                <ClientScroll
                    {...clientScrollData}
                    darkLayout={true}
                    classname="dark"
                />
            </section>
            <section className={classes.tabsSection}>
                <div className={classes.absoulteCard}>
                    <TruestedSection shadow={true} background={true} />
                </div>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Applications and use cases across industries
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            With smart CRM messaging with AI, Pepper Cloud transforms everyday conversations into opportunities. No matter the industry, this intelligent feature helps teams reply faster, automate actions, and keep everything organised in one place.
                        </motion.p>
                        <div className={classes.tabsContainer}>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 0 && "active"
                                )}
                                onClick={() => setActiveRealWorld(0)}
                            >
                                Real estate
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 1 && "active"
                                )}
                                onClick={() => setActiveRealWorld(1)}
                            >
                                Education
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 2 && "active"
                                )}
                                onClick={() => setActiveRealWorld(2)}
                            >
                                Finance and insurance
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 3 && "active"
                                )}
                                onClick={() => setActiveRealWorld(3)}
                            >
                                E-commerce
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 4 && "active"
                                )}
                                onClick={() => setActiveRealWorld(4)}
                            >
                                Travel agency
                            </div>
                        </div>
                    </div>
                    <div className={classes.tabCard}>
                        <div className={classes.tabCardLeftContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <div>
                                            <motion.p
                                                initial={{ opacity: 0, x: -20 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.3 }}
                                                className="font-wix-regular font-18 font-white"
                                            >
                                                {listItem.subtitle}
                                            </motion.p>
                                            <div className={classes.tabListContainer}>
                                                {listItem.tabContent.map((item) => (
                                                    <motion.div
                                                        initial={{ opacity: 0, x: -20 }}
                                                        whileInView={{ opacity: 1, x: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        className={classes.tabListItem}
                                                    >
                                                        <LazyImage
                                                            source={greenCheckCircle}
                                                            className={classes.tabIcon}
                                                            alt={item.alt}
                                                        />
                                                        <div className={classes.tabListItemContent}>
                                                            <p className="font-wix-semibold font-18 font-white">
                                                                {item.title}:
                                                            </p>
                                                            <p className="font-wix-regular font-18 font-white">
                                                                {item.content}
                                                            </p>
                                                        </div>
                                                    </motion.div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                        <div className={classes.tabCardRightContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <motion.div
                                            initial={{ opacity: 1, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                        // className={classes.aiSectionRight}
                                        >
                                            <LazyImage
                                                source={listItem.img}
                                                alt={listItem.alt}
                                                width={"100%"}
                                            />
                                        </motion.div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <TestimonialSlider desc={"Discover how businesses are transforming customer engagement with Pepper Cloud."} heading={"Real stories. Real results."} noButton={true} />
            <section className={classes.trustedSection}>
                <div className='container'>
                    <div className="trustedHeading">
                        <motion.h3
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-24 font-black1"
                        >
                            Trusted by leading businesses for outstanding efficiency
                        </motion.h3>
                    </div>
                </div>
                <Swiper
                    className={classes.partnerSlider}
                    slidesPerView="auto"
                    spaceBetween={60}
                    loop={true}
                    speed={2000}
                    modules={[Autoplay]}
                    allowTouchMove={false}
                    autoplay={{
                        delay: 100,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }}
                >
                    {partners.map((partner) => (
                        <SwiperSlide className={classes.partnerSlide}>
                            <img src={partner.icon} alt={partner.alt} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
            <div className={classes.wpFaq}>
                <FaqSection
                    backgroundColor={"#E0EFFD"}
                    heading={"Frequently asked questions about smart CRM messaging with AI"}
                    faqs={faqs}
                />
            </div>
            <section className={classes.commonPageFooterSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            className="font-wix-medium font-56 font-white"
                            initial={{ opacity: 1, y: 30 }}
                            transition={{ duration: 0.5 }}
                            whileInView={{ opacity: 1, y: 0 }}
                        >
                            Start writing smarter messages today with Pepper Cloud’s AI communication assistant.
                        </motion.h2>
                        <Link
                            className="primaryButton font-20 font-wix-medium font-white"
                            to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                             style={{padding:'8px 32px'}}
                        >
                            Get started
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default AiMessageModule